import type { ReactElement } from "react";
import "./MarkdownHinweis.css";

/**
 * Der Satz unter einem Eingabefeld, dessen Text als MARKDOWN gesetzt wird.
 *
 * **Warum es ihn gibt.** Die Belegtexte (Einleitung und Ausleitung an Angebot, Auftrag und
 * Rechnung sowie in der Angebotsvorlage), die Artikelbeschreibung und die Textbausteine
 * werden als Rohtext getippt und als Markdown gesetzt — in der Anzeige durch
 * `renderMarkdown` (markdown.tsx, `kn-md`-Präfix) und im Beleg-PDF durch die Render-Engine,
 * die dieselben Auszeichnungen kennt. Wer das nicht weiss, tippt entweder Sterne, die er
 * nicht meint, oder verzichtet auf eine Auszeichnung, die er hätte haben können. Ein Feld,
 * das seine eigene Sprache verschweigt, ist ein Rätsel.
 *
 * **Warum EIN Baustein und nicht sechs Sätze.** Der Satz ist an allen sechs Stellen
 * derselbe, und das muss er bleiben: Sechs abgetippte Fassungen wären eines Tages fünf
 * verschiedene, und die eine, die eine neue Auszeichnung nicht nennt, fiele niemandem auf.
 * Aus demselben Grund steht die Aufzählung der Beispiele HIER und nicht am Aufrufer.
 *
 * **Warum kein `aria-describedby`.** Der Hinweis gehört zum Feld, aber er ist keine
 * Anweisung zu SEINEM Inhalt — er beschreibt, wie der Text später gesetzt wird. Als
 * Beschreibung angehängt läse ihn ein Vorleser bei JEDEM Betreten des Feldes mit vor, auch
 * beim zwanzigsten Mal; als eigener Absatz danach steht er da, wo man ihn sucht, und lässt
 * sich überspringen. Wer ihn will, findet ihn beim Durchgehen der Seite.
 */
export function MarkdownHinweis(): ReactElement {
  return (
    <p className="mdh">
      Markdown wirkt in Anzeige und Beleg-PDF
      {" "}
      <span className="mdh__beispiele">(###, **fett**, _kursiv_, Listen)</span>
    </p>
  );
}
